// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"46fc9359","287":"4b09f7a2","425":"d44fce4f"}[chunkId] + ".chunk.js";
};